import { Alert, AlertIcon, Box } from '@chakra-ui/react';
import { djs } from '@duke-hq/djs';
import { Trans } from '@lingui/react/macro';
import type { StudentType } from './StudentDetailPage';
import { testIds } from './testIds';

export function StudentDeletedAlert({ student }: { student: StudentType }): React.ReactNode {
  if (student.deleted_at == null) {
    return null;
  }

  return (
    <Box px={4} pt={4}>
      <Alert status="warning" data-testid={testIds.deletedStudentNotice}>
        <AlertIcon />
        <Trans>
          Deleted on {djs(student.deleted_at).format('D MMMM YYYY')}. Sign in is blocked for this
          user and their email address has been updated to {student.email} to avoid any accidental
          notifications.
        </Trans>
      </Alert>
    </Box>
  );
}
